module.exports = __webpack_public_path__ + "media/images/contest_banners/contests-5-banner@3x-ec5838fb8c68413db13c0eda7f02ec22.png";